import { PlentyGoalAccountFinancialEntity } from '../../financialEntities';
import { Goal } from '../../goals';

export const getGoalAccounts = (
    goal: Goal
): PlentyGoalAccountFinancialEntity[] => {
    // @ts-expect-error TODO: Try to improve the typing here
    return goal.financialEntities.filter(
        (fe) =>
            fe.type === 'PlentyGoalAccount' &&
            fe.info.feType === 'PlentyGoalAccount'
    );
};
